import { render, staticRenderFns } from "./ModalIkpMedParamDetail.vue?vue&type=template&id=2ff30588&scoped=true"
import script from "./ModalIkpMedParamDetail.vue?vue&type=script&lang=js"
export * from "./ModalIkpMedParamDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff30588",
  null
  
)

export default component.exports